import React, { useEffect } from 'react';
import FormCard from '../FormCard/FormCard';
import { useState } from 'react';
import { useAppContext } from '../../../../Services/AppContext';
import { joinClasses } from '../../../../Utils/className.util';
import styles from './TimePickerCustom.module.scss';
import moment from 'moment';

export interface CustomTimePickerTime {
	date: string;
	from: string;
	to: string;
	price?: string;
	priceId?: string;
}

interface Props {
	times: CustomTimePickerTime[];
	onChange: (time: CustomTimePickerTime) => void;
	preselectedDateTime?: string;
}

const TimePickerCustom: React.FC<Props> = ({
	times,
	onChange,
	preselectedDateTime,
}) => {
	const { translation } = useAppContext();

	const toggled = true;
	const [selected, setSelected] = useState<CustomTimePickerTime | undefined>(
		undefined,
	);

	const handleSelectTime = (time: CustomTimePickerTime) => {
		setSelected(time);
		onChange(time);
	};

	useEffect(() => {
		if (preselectedDateTime && !selected) {
			const time = times.find(
				item =>
					item.date + item.from ===
					moment(preselectedDateTime).format('YYYY-MM-DDHH:mm'),
			);
			if (time) {
				handleSelectTime(time);
			}
		}
	}, [times, preselectedDateTime]);

	return (
		<FormCard style={{ height: '100%' }}>
			<div className={`custom-picker ${toggled ? 'toggled picked' : ''}`}>
				<div className='custom-picker__header'>
					<div className='custom-picker__header__content'>
						<div className='custom-picker__header__content__title'>
							{translation['base.shared.time']}
						</div>
						<div className='custom-picker__header__content__value'>
							{selected
								? selected.from + ' - ' + selected.to
								: translation['base.pickTime']}
						</div>
					</div>
					<div className='custom-picker__header__icon'>
						<i className='fa-solid fa-angle-down' />
					</div>
				</div>
				{toggled && (
					<>
						<hr />
						<div className='custom-picker__body'>
							{times && times.length > 0 && (
								<>
									{times.map((time, index) => {
										const active =
											selected &&
											selected.date === time.date &&
											selected.from === time.from &&
											selected.to === time.to;

										return (
											<div
												key={index}
												className={joinClasses([
													'custom-picker__body__item',
													active ? 'active' : '',
													active ? styles.active : '',
													styles.wrapper,
												])}
												onClick={() => handleSelectTime(time)}
											>
												<div className={styles.interval}>
													{time.from} - {time.to}
												</div>
												{time.price && (
													<div className={styles.price}>{time.price}</div>
												)}
											</div>
										);
									})}
								</>
							)}
						</div>
					</>
				)}
			</div>
		</FormCard>
	);
};

export default TimePickerCustom;
